export type EnvironmentDynamic = Readonly<{
  buildVersion: string
}>

export type EnvironmentConfig = EnvironmentDynamic & Readonly<{
  production: boolean
  environmentName: string
  apiUrl: string
}>

export const dynamicEnvironment: EnvironmentDynamic = {
  buildVersion: '202605210927',
} 
